import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CampaignRoutingModule } from './campaign-routing.module';
import { ManageCampaignComponent } from './manage-campaign/manage-campaign.component';
import { CrudCampaignComponent } from './crud-campaign/crud-campaign.component';
import { CommonComponentModule } from 'projects/app-core/src/app/components/commoncomponent.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTagModule } from 'ng-zorro-antd/tag';

@NgModule({
  declarations: [ManageCampaignComponent, CrudCampaignComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CampaignRoutingModule,
    CommonComponentModule,
    NzSpinModule,
    NzInputModule,
    NzSelectModule,
    NzGridModule,
    NzTableModule,
    NzDividerModule,
    NzDropDownModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzSwitchModule,
    NzButtonModule,
    NzIconModule,
    NzFormModule,
    NzCardModule,
    NzModalModule,
    NzToolTipModule,
    NzTagModule,
  ],
})
export class CampaignModule {}
